export default "__VITE_ASSET__1c666a0b__"